import React from "react";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import SpeciesFilters from "../components/species/SpeciesFilters";
import SpeciesGrid from "../components/species/SpeciesGrid";
import { useSpeciesFiltering } from "../hooks/species/useSpeciesFiltering";
import useGET from "../services/useGET";
import { useLocation } from "react-router-dom";

export default function SpeciesInfo() {
    // Fetch data from API
    const { data: species } = useGET(`${process.env.REACT_APP_API_URL}/api/species`);
    const { data: areas } = useGET(`${process.env.REACT_APP_API_URL}/api/areas`);
    const { data: sounds } = useGET(`${process.env.REACT_APP_API_URL}/api/species/sounds`);

    //This is a fix for rerouting mobile users from map to species with a filter remove once mobile map page specieslist is prettier
    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    const incomingArea = query.get("area") || "";
    //end of above comment
    
    const filterState = useSpeciesFiltering(species, areas, incomingArea);

    return (
        <div className="flex flex-col min-h-screen bg-offwhite font-body">
            {/* Navbar */}
            <Navbar />

            <main className="flex-grow pt-[56px]">
                {/* Header Section */}
                <div className="bg-offwhite py-12">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <h1 className="font-heading text-4xl font-bold text-charcoal text-center sm:text-5xl">
                            Artbank
                        </h1>
                        <p className="mt-4 text-center text-charcoal/80 max-w-2xl mx-auto">
                            Utforska och lär dig om Sveriges fantastiska flora och fauna
                        </p>
                    </div>
                </div>

                {/* Search and Filter Section */}
                <SpeciesFilters
                    searchTerm={filterState.searchTerm}
                    setSearchTerm={filterState.setSearchTerm}
                    selectedCategory={filterState.selectedCategory}
                    setSelectedCategory={filterState.setSelectedCategory}
                    selectedArea={filterState.selectedArea}
                    handleAreaFilterChange={filterState.handleAreaFilterChange}
                    categories={filterState.categories}
                    areas={areas}
                />

                {/* Species Cards Section */}
                <SpeciesGrid
                    groupedSpecies={filterState.groupedSpecies}
                    speciesAreaMap={filterState.speciesAreaMap}
                    speciesImages={filterState.speciesImages}
                    loadingImages={filterState.loadingImages}
                    sounds={sounds}
                    fetchSpeciesImage={filterState.fetchSpeciesImage}
                />
            </main>

            <Footer />

            {/* Scroll to Top Button */}
            {filterState.showScrollTop && (
                <button
                    onClick={filterState.scrollToTop}
                    className="fixed bottom-8 right-8 bg-forest text-white p-4 rounded-full shadow-lg hover:bg-leaf transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-forest focus:ring-offset-2 z-50"
                    aria-label="Scrolla till toppen"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                    </svg>
                </button>
            )}
        </div>
    );
}
